import React, { Component } from "react";

export class Redirect extends Component {
  constructor( props ){
    super();
    this.state = { ...props };
  }
  componentWillMount(){
    if(this.state.location.pathname == '/home/app'){
        window.location = "https://flowpaper.com/app/";
    }
  }
  render(){
    return (<div className="content">Redirecting...</div>);
  }
}

export default Redirect;